import React, {useEffect, useState} from "react";
import {mayBe} from "./utils";
import {DocRow, DocTitle} from "../../components";
import {QRFooter} from "../qr_footer/QRFooter";
import {RefpassDocument, RefpassResponse} from "../../types/refpass";
import {DocumentsBatch} from "../../types";
import {selectedDocument} from "./index";
import {AvailableDocuments} from "./AvailableDocuments";


export const RefpassDoc: React.FC<{ documents: DocumentsBatch , withVersions?: boolean }> = ({
                                                                                                 documents,
                                                                                                 withVersions = true
                                                                                             }) => {

    const [selectedDocument, setSelectedDocument] = useState<selectedDocument>(
            {
                document: documents.documents[0],
                documentTypeName: documents.documentsType
            });

    const [doc, setDocument] = useState<RefpassResponse>(
            selectedDocument.document.document as RefpassResponse
    )

    useEffect(() => {
        setDocument(selectedDocument.document.document as RefpassResponse);
    }, [selectedDocument.document.version]);


    const title = `Справка о выданном паспорте № ${mayBe(doc.refNumber) || 'б/н'}`;
    const subTitle = `Выдана заявителю:`;

    const getDocument = (document: RefpassDocument) => {
        const {documentType, serial = '', number = '', issuedBy = '', issuedDate = ''} = document;
        if (!serial && !number && !issuedBy && !issuedDate) {
            return documentType;
        }
        return `${documentType} ${serial} №${number} выдан ${issuedBy} от ${issuedDate}`;
    };

    return (
            <>

                <div className="col-span-12 md:col-span-12">
                    <DocTitle title={title} subtitle={subTitle} uid={doc.blockchainUid}/>
                </div>

                <div className="col-span-12 md:col-span-8">
                    <div className="pl-3 pb-5 bottom-line">
                        <DocRow title="Фамилия" bold value={mayBe(doc.personInfo.lastName)}/>
                        <DocRow title="Имя" bold value={mayBe(doc.personInfo.firstName)}/>
                        <DocRow title="Отчество" bold value={mayBe(doc.personInfo.midName)}/>
                        <DocRow title="Дата рождения" bold value={mayBe(doc.personInfo.birthdate) || '-'}/>
                        <DocRow
                                title="Документ удостоверяющий личность"
                                bold
                                value={getDocument(doc.personInfo.document)}
                        />
                    </div>
                  { doc.documentsOld && <>
                    <DocTitle subtitle={doc.documentsOld.length > 2
                            ? 'Сведения о ранее выданном паспорте'
                            : 'Сведения о ранее выданных паспортах'}
                              title={''}/>
                    {doc.documentsOld.map(pass =>
                            <div className="pl-3 pb-5 pt-5 bottom-line" key={pass.number}>
                                <DocRow title="Паспорт" bold value={getDocument(pass)}/>
                                <DocRow title="Причина замены паспорта" bold
                                        value={mayBe(pass.issuedReason) || 'Данные отсутствуют'}/>
                            </div>
                    )}
                  </>
                }
                </div>

                {
                        withVersions && documents.documents.length > 0 &&
                        <div className="col-span-12 md:col-end-13 md:col-span-3 order-first md:order-3">
                            <AvailableDocuments
                                    docs={documents}
                                    setSelectedDocument={setSelectedDocument}
                                    className={'md:-mt-12 mb-5'}
                            />
                        </div>
                }

                <div className="col-span-12 md:col-span-8 md:order-last">
                    <DocTitle title={''}
                              subtitle={'Заявитель зарегистрирован по месту жительства'}/>
                    <div className="pl-3 pb-5 bottom-line">
                        <DocRow title="Адрес регистрации" bold value={mayBe(doc.personInfo.regAddress)}/>
                    </div>


                    <QRFooter blockchainUid={doc.blockchainUid}
                              refDate={doc.refDate}
                              mfcInfoName={doc.mfcInfo.name}
                              mfcUserName={doc.mfcUser.name}
                    />
                </div>

            </>
    );
};
